// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="./client-utils-env.d.ts" />

export { getProductImageURL, getProductImageSizes, getProductResponsiveImagesForSizes } from "./product/presetImageSizeHelpers";
export { atLeastOneValueTruthy } from "./utils/atLeastOneValueTruthy";
import * as _dateUtils from "./utils/date";
export { _dateUtils as dateUtils };
export { formatDate } from "./utils/dateFormatter";
export { debounce } from "./utils/debounce";
export { getDeliveryByEventLabel, getDeliveryByEventName } from "./utils/deliveryByEvent";
export { linkClickOpensInNewTab } from "./utils/dom";
export { fetchJSONWithTimeout, fetchWithTimeout } from "./utils/fetch";
export { getAnchorElementFromEvent } from "./utils/getAnchorElementFromEvent";
export { getContentstackImagesForWidths, getContentstackImageURL } from "./utils/getContentstackImageURL";
export { getProductIdFromProductCode, getProductCodeFromProductId } from "./utils/product";
export { PROMISE_SUPERSEDED_ERROR_MESSAGE, rejectSupersededInvocation } from "./utils/promise";
export { isBrowser } from "./utils/isBrowser";
export { isKeyboardTriggeredEvent } from "./utils/isKeyboardTriggeredEvent";
export { MIDDLE_MOUSE_CLICK_BUTTON, isMiddleMouseClick } from "./utils/mouse";
export { getOrdinalSuffix, isNumber, isBetween } from "./utils/number";
export { cloneObjectWithPrefixedProperties, cloneObjectWithCollapsingProperties } from "./utils/object";
export { getPagePosition, getRect } from "./utils/position";
export { priceFormatter } from "./utils/priceFormatter";
export { animatedScrollTo } from "./utils/scroll";
export { generateRandomString, toSentenceCase } from "./utils/string";
export { addRUMTiming } from "./telemetry/rum";
export { addParamsToHref, getPathnameFromUrl } from "./utils/url";